// extracted by mini-css-extract-plugin
export default {"page":"page__NLN5YiTL","modalWrapper":"modal-wrapper__god7ZQzU"};